<template>
    <div class="content">
        
  <!-- 
    - #FOOTER
  -->

  <footer class="footer">
    <div class="footer-top section">
      <div class="container" style=" justify-content: space-between !important;">
        <div class="footer-brand">
          <a href="#" class="logo">360</a>

        </div>

        <ul class="footer-list">
          <li>
            <p class="footer-list-title">Our links</p>
          </li>

          <li>
            <a href="#" class="footer-link">Home</a>
          </li>

          <li>
            <a href="#about" class="footer-link">About Us</a>
          </li>

          <li>
            <a href="#services" class="footer-link">Services</a>
          </li>

      

   
        </ul>

        <ul class="footer-list">
          <li>
            <p class="footer-list-title">Our Services</p>
          </li>

          <li>
       
              <p>Strategy</p>
          </li>

          <li>
             <p>People</p>
          </li>

          <li>
            <p>Revenue</p>
          </li>


        </ul>



        <ul class="footer-list">
          <li>
            <p class="footer-list-title">Contact Us</p>
          </li>

          <li class="footer-item">
            <div class="footer-item-icon">
              <ion-icon name="call"></ion-icon>
            </div>

            <div>
              <a href="#" class="footer-item-link"
                >+238 262 05 00 </a
              >
        
            </div>
          </li>

          <li class="footer-item">
            <div class="footer-item-icon">
              <ion-icon name="mail"></ion-icon>
            </div>

            <div>
              <a href="mailto:geral@360spr.cv" class="footer-item-link"
                >geral@360spr.cv</a
              >
         
            </div>
          </li>

          <li class="footer-item">
            <div class="footer-item-icon">
              <ion-icon name="location"></ion-icon>
            </div>

            <address class="footer-item-link">
              360 SPR
            </address>
          </li>
        </ul>
      </div>
    </div>
  <!-- 
    <div class="footer-bottom">
      <p class="copyright">
        &copy; 2026 <a href="rise.ao" target="_blank" class="copyright-link"> RISE </a>
      </p>
    </div>
      -->
  </footer>


   


  <a href="#top" class="go-top active" aria-label="Go To Top" data-go-top>
 <i class="fa fa-solid fa-arrow-up"></i>

  </a>

    </div>
</template>

<style scoped>
   .footer-bottom{
    background-color: #fef6f2;
   } 
   .copyright{
    color: var(--title-color);
   }
   .footer-item{
    padding-block: 2px !important;
   }
   .active {
    background-color: var(--title-color);
    box-shadow:none;
   }
.container{
  padding: 1%;
}
</style>

